import React from 'react';
import styled from 'styled-components';

interface ThankYouPopupProps {
    isOpen: boolean;
    onClose: () => void;
}

const ThankYouPopup: React.FC<ThankYouPopupProps> = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <Overlay onClick={onClose}>
            <PopupContainer
                onClick={(e: React.MouseEvent) => e.stopPropagation()}
            >
                <CloseButton onClick={onClose}>
                    <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d='M18 6L6 18M6 6L18 18'
                            stroke='currentColor'
                            strokeWidth='2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                    </svg>
                </CloseButton>

                <Content>
                    <IconContainer>
                        <svg
                            width='48'
                            height='48'
                            viewBox='0 0 24 24'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z'
                                stroke='#28bd75'
                                strokeWidth='2'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                            />
                        </svg>
                    </IconContainer>

                    <Title>Thank you!</Title>

                    <Message>Blocsys will be in touch with you soon.</Message>

                    <CloseButtonText onClick={onClose}>OK</CloseButtonText>
                </Content>
            </PopupContainer>
        </Overlay>
    );
};

const Overlay = styled.div`
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.9);
    z-index: 9999;
    backdrop-filter: blur(25px);
    -webkit-backdrop-filter: blur(25px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    transform: translateZ(0);
    min-height: 100vh;
    height: 100vh;
    will-change: backdrop-filter;
`;

const PopupContainer = styled.div`
    background: #ffffff;
    border-radius: 20px;
    padding: 40px;
    max-width: 400px;
    width: 90%;
    position: relative;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
        0 10px 10px -5px rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(0, 0, 0, 0.1);
    animation: slideIn 0.3s ease-out;

    @keyframes slideIn {
        from {
            transform: scale(0.8);
            opacity: 0;
        }
        to {
            transform: scale(1);
            opacity: 1;
        }
    }
`;

const CloseButton = styled.button`
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    cursor: pointer;
    color: #6b7280;
    padding: 8px;
    border-radius: 8px;
    transition: all 0.2s ease;

    &:hover {
        background-color: #f3f4f6;
        color: #374151;
    }

    svg {
        width: 20px;
        height: 20px;
    }
`;

const Content = styled.div`
    text-align: center;
    width: 100%;
`;

const IconContainer = styled.div`
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
`;

const Title = styled.h2`
    color: #1a1e23;
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: 600;
`;

const Message = styled.p`
    color: #1a1e23;
    margin-bottom: 20px;
    line-height: 1.6;
    font-size: 14px;
    letter-spacing: -0.7px;
    text-align: center;
`;

const CloseButtonText = styled.button`
    width: 100%;
    font-family: 'Inter', sans-serif !important;
    font-size: 16px;
    font-weight: 600;
    border-radius: 10px !important;
    min-width: 160px;
    min-height: 44px;
    padding: 10px 20px;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    background: #28bd75;
    color: #ffffff;
    box-shadow: 0 4px 12px rgba(40, 189, 117, 0.3);
    text-transform: none;
    letter-spacing: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: 0 auto;

    &:hover {
        background: #1e9f63;
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(40, 189, 117, 0.4);
    }

    &:active {
        transform: translateY(0);
    }

    &:disabled {
        background: #9ca3af;
        color: #ffffff;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }

    @media (max-width: 768px) {
        height: 44px;
        font-size: 15px;
    }
`;

export default ThankYouPopup;
